import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import CopyIcon from '@material-ui/icons/FilterNone';

import { connect } from 'react-redux';
import { showNotification as showNotificationAction } from 'react-admin';
import { push as pushAction } from 'react-router-redux';
import { UPDATE } from 'react-admin';

import isPresent from '../Utils/Present';
import RestClient from '../../Framework/RestClient';

type Props = {
  basePath: string,
  push: any,
  record: any,
  showNotification: any
};

class CloneButton extends Component<Props> {
  handleClick = () => {
    const { push, record, showNotification } = this.props;
    const updatedRecord = { ...record, copy: true };

    RestClient(UPDATE, `${this.props.basePath}/copy`, { id: record.id, data: updatedRecord })
      .then((response) => {
        showNotification('Cloned successfully');
        push(`${this.props.basePath}/${response.data.id}`);
      })
      .catch((e) => {
        if (isPresent(e.body)) {
          showNotification(e.body.message, 'warning');
        } else {
          showNotification('Error processing the request', 'warning');
        }
      });
  }

  render() {
    return (
      <Button variant="text" title="Clone" onClick={this.handleClick}><CopyIcon /></Button>
    );
  }
}

export default connect(null, {
  showNotification: showNotificationAction,
  push: pushAction,
})(CloneButton);



// WEBPACK FOOTER //
// ./src/views/Common/Buttons/Clone.tsx